/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GameEntity } from './GameEntity';

export enum REDIRECT_REASON {
  CURRENCY_CRYPTO = 'currency:crypto',
  CURRENCY_FIAT = 'currency:fiat',
}

export type GamesRedirectEntity = {
  gameId: string;
  isRedirected: boolean;
  redirectGameId: string | null;
  reason: REDIRECT_REASON | null;
  redirectGame?: GameEntity;
};

